import React, { useEffect, useState } from 'react'
import getServices from '../../Services/get-service';
import swal from 'sweetalert';
import { TablePagination } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import House from '../../Assets/images/hh.png';
import ListingCard from '../Listing/ListingCard';
import ListingDrawer from '../Listing/ListingDrawer';
import ListPropertyDrawer from '../Listing/ListPropertyDrawer';
function Listing() {
  const [projects, setProjects] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(0)
  const [open, setOpen] = useState(false)
  const handleClose = () => setOpen(false)
  const [open1, setOpen1] = useState(false)
  const handleClose1 = () => setOpen1(false)
  const [id, setId] = useState()
  const [selectedDetails, setSelectedDetails] = useState({})

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const fetchSavedListings = () => {
    setLoading(true);
    getServices.getProjectBuyLater(rowsPerPage, page).then(
      (response) => {
        setLoading(false);
        if (response?.data?.statusCode === 200 || response?.status === 200) {
          const rawData = response.data?.data ?? response.data;
          let allSaved = [];
          if (Array.isArray(rawData)) allSaved = rawData;
          else if (rawData && Array.isArray(rawData.savedProjects)) allSaved = rawData.savedProjects;
          else if (rawData && Array.isArray(rawData.content)) allSaved = rawData.content;
          else if (rawData && Array.isArray(rawData.projects)) allSaved = rawData.projects;
          else if (rawData && Array.isArray(rawData.data)) allSaved = rawData.data;

          setProjects(allSaved);
        } else {
          setProjects([]);
        }
      },
      (error) => {
        setLoading(false);
        setProjects([]);
      }
    );
  };

  useEffect(() => {
    fetchSavedListings();
  }, [page, rowsPerPage]);

  const displayProjects = Array.isArray(projects) ? projects : [];

  return (
    <div className=' mt-4'>
      <ListingDrawer
        open={open}
        handleClose={handleClose}
        id={id}
      />
      <ListPropertyDrawer
        open={open1}
        handleClose={handleClose1}
        id={id}
        details={selectedDetails}
      />
      <div className=' grid sm:grid-cols-1 lg:grid-cols-2 gap-4'>
        {loading ? (
          [1, 2, 3, 4].map((item) => (
            <div key={item} className=" my-4 border border-[#E5E7EB] rounded-lg bg-white overflow-hidden">
              <div className=" p-4">
                <Skeleton variant="text" width="40%" height={24} sx={{ mb: 2 }} />
                <div className=" grid grid-cols-5 gap-6">
                  <div className="col-span-2">
                    <Skeleton variant="rectangular" height={100} width="100%" sx={{ borderRadius: 1 }} />
                  </div>
                  <div className=" col-span-3">
                    <Skeleton variant="text" width="30%" height={20} sx={{ mb: 1 }} />
                    <Skeleton variant="text" width="60%" height={20} sx={{ mb: 1 }} />
                    <Skeleton variant="text" width="90%" height={16} sx={{ mb: 1 }} />
                    <Skeleton variant="text" width="40%" height={14} sx={{ mb: 2 }} />
                    <div className=" my-2 border-t border-gray-100"></div>
                    <Skeleton variant="text" width="50%" height={20} />
                  </div>
                </div>
              </div>
              <div className=" p-3 border-t border-[#E5E7EB] bg-[#F8FAFC] flex justify-between">
                <Skeleton variant="text" width="30%" height={20} />
                <Skeleton variant="text" width="20%" height={20} />
              </div>
            </div>
          ))
        ) : (
          displayProjects.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((project, idx) => {
              const item = project?.property || project?.project || project?.savedProject || project || {};
              const title = item.title || item.name || project.title || project.name || "Listing";
              const propId = project.propertyId || project.projectId || project.id || item.propertyId || item.id || idx;
              const header = item.propertyType || item.projectType || project.propertyType || project.projectType || "Listing";
              const location = [item.street, item.locality].filter(Boolean).join(", ") || item.location || project.location || item.locality || "";
              const img = item.imageUrl 
                ? (Array.isArray(item.imageUrl) ? item.imageUrl[0] : item.imageUrl) 
                : (item.projectImages && item.projectImages[0]?.imageUrl) || project.imageUrl || (project.projectImages && project.projectImages[0]?.imageUrl) || House;
              const dis = (item.description ?? project.description ?? "")?.toString()?.slice(0, 150);
              const date = item.createdDate || item.createdAt || project.createdDate || project.createdAt;
              const amount = item.price ?? project.price ?? 0;
              const area = item.totalArea || item.totalAreas || item.coveredAreas || project.totalArea || project.totalAreas || "";

              return <div key={propId}>
                <ListingCard
                  id={propId}
                  title={title}
                  image={img}
                  type={header}
                  location={location}
                  description={dis}
                  dateAdded={date}
                  price={amount}
                  areaCovered={area}
                  isSaved={true}
                  onSaveToggle={(id, isSavedNow) => {
                    if (!isSavedNow) {
                      setProjects(prev => (Array.isArray(prev) ? prev.filter(p => {
                        const pId = p.propertyId || p.projectId || p.id || p.property?.id || p.project?.id;
                        return String(pId) !== String(id);
                      }) : []));
                    }
                  }}
                  onClick={() => {
                    (header?.toString()?.toLowerCase()?.includes('property')) ?
                      setOpen1(true) :
                      setOpen(true)
                    setId(propId)
                    setSelectedDetails(item)
                  }}
                />

              </div>

            })
        )}

      </div>
      {!loading && displayProjects.length === 0 && (
        <div className="flex flex-col items-center justify-center mt-20">
          <div className="bg-white p-4 rounded-full shadow-sm mb-4">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#00BC67"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">No Saved Properties</h3>
        </div>
      )}
      <div className=' flex justify-center'>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={displayProjects.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </div>
  )
}

export default Listing